import { Injectable } from '@angular/core';
import { AgCellLocalStoreService, AgCellState } from '../../../../global/gx-ag-grid/ag-cell-local-store.service';
import { MarkerLocation } from '../../../map/map-utils';
import { Observable, switchMap } from 'rxjs';
import { Store } from '@ngrx/store';
import { ICellRendererParams } from 'ag-grid-community';
import { selectFocusedRowId } from '../../state/location-list-selectors';
import { selectIsCvOn } from '../../../state/location-skeleton-combined-selectors';
import { selectMarkerLocation } from '../../../map/state/map-combined.selectors';
import { Location } from '../../../../../models/locations-models/location';

export interface RowMenuCellState extends AgCellState {}
export interface RowMenuViewModel {
  markerLocation: MarkerLocation,
  isCvOn: boolean,
  params: ICellRendererParams<Location>,
  isFocused: boolean
}

@Injectable()
export class RowMenuCellLocalStoreService extends AgCellLocalStoreService<RowMenuCellState>{

  readonly viewModel$: Observable<RowMenuViewModel> = this.params$

  .pipe(switchMap((params: ICellRendererParams<Location>) =>
      this.select(this.store.select(selectMarkerLocation(params?.data)),
          this.store.select(selectIsCvOn),
          this.params$,
          this.store.select(selectFocusedRowId),
          (markerLocation, isCvOn, params, focusedRowId) => {
            return {
              markerLocation,
              isCvOn,
              params,
              isFocused: focusedRowId === params?.data?.id
            }
          })
  ));

  constructor(private store: Store) {
    super({
      cellValue: '',
      params: null
    })
  }
}
